import React, { Component } from 'react';

import Link from '@material-ui/core/Link';

export class Copyright extends Component {
    render() {
        return (
            <div className="text-align-center">
            {'COPYRIGHT © '}
            {' '}
            {new Date().getFullYear()}
            {'.'}
            <Link color="inherit" href="https://www.hyundaielevator.co.kr/" target="_blank">
                HYUNDAIELEVATOR Co.,LTD. ALL RIGHTS RESERVED.
            </Link>
            </div>
        );
    }
}